import { render } from "./EditTesti.vue?vue&type=template&id=0c75d380"
import script from "./EditTesti.vue?vue&type=script&lang=js"
export * from "./EditTesti.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__